import React from 'react';
import './LoadingSpinner.css';
import logoAnimacion from '../../assets/logos/logoAnimacion.png';

const LoadingSpinner = ({ message = 'Cargando...', size = 'medium', color = 'primary', inline = false }) => {
  return (
    <div className={inline ? 'loading-spinner-inline' : 'loading-spinner-overlay'}>
      <div className="loading-spinner-container">
        <div className={`loading-spinner ${size} ${color}`}>
          <img
            src={logoAnimacion}
            alt="aluxIA"
            className="spinner-logo spinner-logo-only"
          />
        </div>
        <p className="loading-message">{message}</p>
      </div>
    </div>
  );
};

export default LoadingSpinner;
